import $ from 'jquery'
import FontFaceObserver from 'fontfaceobserver'
import StateManager from '../scuba/StateManager'

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  const bold = new FontFaceObserver('paris-belleville', {
    weight: 700
  })
  const regular = new FontFaceObserver('paris-belleville', {
    weight: 600
  })
  const light = new FontFaceObserver('paris-belleville', {
    weight: 400
  })
  const thin = new FontFaceObserver('paris-belleville', {
    weight: 300
  })
  bold.load(null, 20000).then(() => {
    $(window).trigger('font-is-loaded')
  })
  regular.load(null, 20000).then(() => {
    $(window).trigger('font-is-loaded')
  })
  light.load(null, 20000).then(() => {
    $(window).trigger('font-is-loaded')
  })
  thin.load(null, 20000).then(() => {
    $(window).trigger('font-is-loaded')
  })
})



// WEBPACK FOOTER //
// ./scripts/components/Fonts.js